export default __webpack_public_path__ + "static/media/template.7bb33e7c.png";